import React, { memo, useEffect, useState, Fragment, useCallback } from "react";
import { inject, observer } from "mobx-react";
import { ArrowLeftCircle, MoreHorizCircle, Trash, User } from "iconoir-react";
import {
  AiOutlineComment,
  AiOutlineDelete,
  AiOutlineQuestionCircle,
  AiFillBank,
  AiOutlineEdit,
} from "react-icons/ai";
import { useNavigate, useParams } from "react-router-dom";
import {
  Menu,
  MenuItem,
  useTheme,
  Box,
  Stepper,
  Step,
  StepLabel,
  StepContent,
} from "@mui/material";
import { Button, Modal, Table, Tag } from "antd";
import SkeletonTable from "../../components/Skeleton/SkeletonTable";
import {
  ASSIGNEE_TYPE,
  MODES,
  SHIFTS,
  TYPE_STATUS,
  submissionMenu,
} from "../../utils/constants";
import { StatusTag } from "../../components/common/StatusTag";
import { AvatarHasName } from "../../components/common/Avatar";
import { getExtensionFile } from "../../utils/common";
import moment from "moment";
import SelectPeoplePopup from "../../components/SelectPeoplePopup";
import SkeletonProposalDetail from "../../components/Skeleton/SkelentonProposalDetail";
import ProposalModal from "./ProposalModal";
import ProposalComment from "./ProposalComment";
import ListComment from "./ListComment";
import AlertDialog from "../../components/common/AlertDialog";
import { ACL_ACTION_TYPE, PROPOSAL_STATUS } from "../../constants";
import FileItem from "../../components/FileItemComponent/FileItem";
import UpdateProposal from "./UpdateModal";
import { message } from "antd";
import { toJS } from "mobx";
import { SelectList } from "../InternalDocumentIncoming/InternalDocumentIncomingDocCreatePageStyled";
import AccessControlAction from "../../components/AccessControlAction/AccessControlAction";
import ProposalActionConfirmModal from "./ProposalActionConfirmModal";
import "./ProposalDetail.css";
const groupBtnStyle = {
  display: "flex",
  justifyContent: "flex-end",
  gap: 10,
  marginBottom: 10,
};
const ProposalDetail = (props) => {
  let {
    proposalStore,
    selectPeopleStore,
    proposalTypeStore,
    authenticationStore,
  } = props;
  const navigate = useNavigate();
  const theme = useTheme();
  const { proposalId } = useParams();
  const [loading, setLoading] = useState(true);
  const [loadingCmt, setLoadingCmt] = useState(false);
  const [handlerList, setHandlerList] = useState([]);
  const [followerList, setFollowerList] = useState([]);
  const [isVisibleSelectUserPopup, setIsVisibleSelectUserPopup] =
    useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [openCmtModal, setOpenCmtModal] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [openMore, setOpenMore] = useState(false);
  const [openCmtDel, setOpenCmtDel] = useState(false);
  const [openEditProposal, setOpenEditProposal] = useState(false);
  const [activeStep, setActiveStep] = useState(0);
  const [approvalLevels, setApprovalLevels] = useState([]);
  const [params, setParams] = useState({
    page: 0,
    size: 10,
    keyword: undefined,
    proposalStatus: undefined,
    type: undefined,
    proposal_permission: undefined,
  });

  const [count, setCount] = useState(0);

  const [deleteItem, setDeleteItem] = useState({
    open: false,
    id_comment: "",
  });
  const [messages, setMessage] = useState({
    title: "",
  });
  const [isOpen, setIsOpen] = useState({
    isOpen: false,
  });

  const [arrSubmissionMenu, setArrSubmissionMenu] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const open = Boolean(anchorEl);

  const {
    otherDetail,
    otherCommentList,
    getOtherComment,
    deleteCommentProposal,
    deleteProposalItem,
  } = proposalStore;
  const { selectUserData, originDepartmentWithUserList } = selectPeopleStore;
  const { currentUser } = authenticationStore;
  // sử lý thêm loại khác vào submissionMenu
  useEffect(() => {
    (async () => {
      proposalStore.clearFilterProposal();
      const response = await proposalTypeStore.getProposalTypes();
      // setProposalTypes(response.data);
      const newProposalTypes = [
        {
          id_group: "3",
          name_group: "Hành chính - Khác",
          child: response.data
            .filter((item) => item.id.includes("OTHER_"))
            .map((item) => ({
              id_child: item.id,
              name_child: item.name,
            })),
        },
      ];
      const updatedSubmissionMenu = submissionMenu.concat(newProposalTypes);
      setArrSubmissionMenu(updatedSubmissionMenu);
    })();
  }, []);
  // xử lý duyệt hành chính
  const [isShowButtonAction, setIsShowButtonAction] = useState(false);
  const [confirmModalType, setConfirmModalType] = useState(null);
  const [isConfirmModalVisible, setIsConfirmModalVisible] = useState(false);
  useEffect(() => {
    if (!currentUser) return;
    const currentStepInfo = proposalStore.otherDetail.approval_levels?.find(
      (item) => item.status === PROPOSAL_STATUS.PENDING
    );
    if (currentUser.username === currentStepInfo?.username) {
      setIsShowButtonAction(true);
    } else {
      setIsShowButtonAction(false);
    }
  }, [proposalStore.otherDetail, currentUser]);

  const handleCloseModal = useCallback(() => {
    setIsConfirmModalVisible(false);
    setConfirmModalType(null);
  }, []);

  const handleOpenConfirmModal = (modalType) => {
    setConfirmModalType(modalType);
    setIsConfirmModalVisible(true);
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        await proposalStore.getOtherDetail(proposalId);
      } catch (err) {
        console.log(err);
        navigate("/proposal");
        await proposalStore.getProposals(params);
        message.error("Không tìm thấy người dùng");
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);
  useEffect(() => {
    proposalStore.getOtherDetail(proposalId);
  }, [count]);
  useEffect(() => {
    (async () => {
      setLoadingCmt(true);
      await getOtherComment(proposalId);
      setLoadingCmt(false);
    })();
  }, []);
  const approvalLevelList = otherDetail?.approval_levels || [];

  const onCommentSuccess = async () => {
    try {
      setLoadingCmt(true);
      await Promise.all([getOtherComment(proposalId)]);
    } catch (err) {
      console.log(err);
    } finally {
      setLoadingCmt(false);
    }
  };

  const ASSIGNEE_TYPE_CONFIG = [
    ASSIGNEE_TYPE.CREATE,
    ASSIGNEE_TYPE.COMBINER,
    ASSIGNEE_TYPE.HANDLER,
    ASSIGNEE_TYPE.LEADER,
  ];

  const commentProposalListNotDeleted = otherCommentList?.filter(
    (item) => item.deleted !== true
  );
  const commentProposalListDeleted = otherCommentList?.filter(
    (item) => item.deleted === true
  );

  const [statusStep, setStatusStep] = useState("process");
  const [workingDaysList, setWorkingDaysList] = useState([]);

  useEffect(() => {
    setWorkingDaysList(otherDetail?.proposalTimeList || []);
  }, [otherDetail?.proposalTimeList]);

  useEffect(() => {
    const length = approvalLevelList.length;
    if (approvalLevelList.length === 0) return;
    let step = 0;
    const pendingStep = approvalLevelList.find(
      item => item.status === PROPOSAL_STATUS.PENDING
    );
    const endStep = approvalLevelList[length - 1];
    const stepRejected = approvalLevelList.find(
      item => item.status === PROPOSAL_STATUS.REJECTED
    );
    if (pendingStep) {
      step = pendingStep.level;
    }
    if (endStep.status === PROPOSAL_STATUS.APPROVED) {
      step = length;
    }
    if (stepRejected) {
      step = stepRejected.level;
      setStatusStep("error");
    }
    setActiveStep(step);
  }, [approvalLevelList]);

  useEffect(() => {
    const approvalLevelsUpdate = approvalLevels.map((item) => {
      if (!item.allow_edit) {
        return item;
      }
      const assignTypeIndex = approvalLevels
        .filter((el) => el.allow_edit)
        .findIndex((el) => el.level === item.level);
      const getUser = (index) => {
        if (![0, 1, 2, 3].includes(index)) {
          return {};
        }
        return selectUserData[ASSIGNEE_TYPE_CONFIG[index]].length > 0
          ? selectUserData[ASSIGNEE_TYPE_CONFIG[index]][0]
          : {};
      };
      return {
        ...item,
        username: getUser(assignTypeIndex).id,
        user: {
          full_name: getUser(assignTypeIndex).full_name,
          image_id: getUser(assignTypeIndex).image_id,
          username: getUser(assignTypeIndex).id,
        },
      };
    });
    setApprovalLevels(approvalLevelsUpdate);
  }, [selectUserData]);

  useEffect(() => {
    proposalStore.setDefaultApprovalConfigUpdate(approvalLevels);
  }, [approvalLevels]);

  const getInfoUser = (username, departmentWithUserList) => {
    const user = {
      full_name: username,
      image_id: null,
      username: username,
    };
    departmentWithUserList.forEach((department) => {
      const userTarget = department.users.find(
        (user) => user.user_name === username
      );
      if (userTarget) {
        user.full_name = userTarget.name_uppercase || username;
        user.image_id = userTarget.image_id;
      }
    });
    return user;
  };

  useEffect(() => {
    const approvalLevelConvert = approvalLevelList.map((item) => {
      return {
        ...item,
        user: getInfoUser(item.username, originDepartmentWithUserList),
      };
    });
    const levelAllowEditList = approvalLevelConvert.filter(
      (item) => item.allow_edit
    );
    let create = null;
    let combiner = null;
    let handler = null;
    let leader = null;
    levelAllowEditList.forEach((item, index) => {
      if (!item.username) return;
      const user = getInfoUser(item.username, originDepartmentWithUserList);
      if (index === 0) {
        create = user;
      }
      if (index === 1) {
        combiner = user;
      }
      if (index === 2) {
        handler = user;
      }
      if (index === 3) {
        leader = user;
      }
    });
    selectPeopleStore.setSelectUserData({
      ...selectUserData,
      [ASSIGNEE_TYPE.CREATE]: create
        ? [
            {
              assignee_type: ASSIGNEE_TYPE.USER,
              full_name: create.full_name,
              id: create.username,
              image_id: create.image_id,
              permission: ASSIGNEE_TYPE.CREATE,
            },
          ]
        : [],
      [ASSIGNEE_TYPE.COMBINER]: combiner
        ? [
            {
              assignee_type: ASSIGNEE_TYPE.USER,
              full_name: combiner.full_name,
              id: combiner.username,
              image_id: combiner.image_id,
              permission: ASSIGNEE_TYPE.COMBINER,
            },
          ]
        : [],
      [ASSIGNEE_TYPE.HANDLER]: handler
        ? [
            {
              assignee_type: ASSIGNEE_TYPE.USER,
              full_name: handler.full_name,
              id: handler.username,
              image_id: handler.image_id,
              permission: ASSIGNEE_TYPE.HANDLER,
            },
          ]
        : [],
      [ASSIGNEE_TYPE.LEADER]: leader
        ? [
            {
              assignee_type: ASSIGNEE_TYPE.USER,
              full_name: leader.full_name,
              id: leader.username,
              image_id: leader.image_id,
              permission: ASSIGNEE_TYPE.LEADER,
            },
          ]
        : [],
    });
    setApprovalLevels(approvalLevelConvert);
  }, [approvalLevelList, originDepartmentWithUserList]);

  const handleOpenSelectUser = (level) => {
    let userType = null;
    const levelAllowEditList = otherDetail.approval_levels?.filter(
      (item) => item.allow_edit
    );
    const indexLevelAllowEdit = levelAllowEditList.findIndex(
      (item) => item.level === level
    );
    if (indexLevelAllowEdit !== -1) {
      userType = ASSIGNEE_TYPE_CONFIG[indexLevelAllowEdit];
    }
    if (userType) {
      selectPeopleStore.setAssigneePopupType(userType);
      setIsVisibleSelectUserPopup(true);
    } else {
      return message.warning("Không rõ chọn người loại nào!");
    }
  };

  const handleSubmitSelectUser = useCallback(() => {
    setIsVisibleSelectUserPopup(false);
  }, []);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleDeleteComment = async () => {
    setDeleteItem({ open: false, comment_id: "" });
    try {
      setLoadingCmt(true);
      await deleteCommentProposal(proposalId, deleteItem.id_comment);
      await getOtherComment(proposalId);
    } catch (err) {
      setMessage({ title: err.vi });
      setIsOpen({ isOpen: true });
    } finally {
      setLoadingCmt(false);
      message.success("Xóa ý kiến thành công!");
    }
  };
  const handleDeleteProposal = async () => {
    try {
      await deleteProposalItem(proposalId);
    } catch (err) {
      console.log(err);
    } finally {
      message.success("Xóa thành công!");
      navigate("/proposal");
    }
  };

  const { confirm } = Modal;
  const showConfirmDeleteProposal = () => {
    confirm({
      title: "Bạn có muốn xóa thông tin này không?",
      icon: (
        <AiOutlineQuestionCircle
          style={{ color: "red", width: "30px", height: "30px" }}
        />
      ),
      okText: "Đồng ý",
      cancelText: "Không",
      okType: "danger",
      onOk() {
        handleDeleteProposal();
      },
    });
  };

  // Chữ cái đầu viết hoa
  const capitalizeFirstLetter = (name) => {
    return name
      .split(" ")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
  };

  let menu = (
    <Menu
      id="basic-menu"
      anchorEl={anchorEl}
      open={open}
      onClose={handleClose}
      MenuListProps={{
        "aria-labelledby": "basic-button",
      }}
    >
      {openMore ? (
        <MenuItem
          sx={{
            color: "#0073C7 !important",
            borderBottom: "1px solid rgba(0,0,0,0.05)",
            fontSize: "12px",
          }}
          onClick={() => {
            setOpenMore(false);
            setOpenCmtDel(false);
            handleClose();
          }}
        >
          <Trash width={12} height={14} className="mr-1" />
          Ẩn ý kiến đã xóa
        </MenuItem>
      ) : (
        <MenuItem
          onClick={() => {
            setOpenMore(true);
            setOpenCmtDel(true);
            handleClose();
          }}
          sx={{
            color: "#0073C7 !important",
            borderBottom: "1px solid rgba(0,0,0,0.05)",
            fontSize: "12px",
          }}
        >
          <Trash width={12} height={14} className="mr-1" />
          Hiện ý kiến đã xóa
        </MenuItem>
      )}
    </Menu>
  );

  const renderStatus = (status, isRejected) => {
    const styleTag = {
      marginTop: 8,
      borderRadius: 10,
    };

    if (status === PROPOSAL_STATUS.PENDING) {
      return (
        <Tag
          color={isRejected ? null : "geekblue"}
          style={{
            ...styleTag,
            opacity: isRejected ? 0.5 : 1,
          }}
        >
          Đến lượt duyệt
        </Tag>
      );
    }
    if (status === PROPOSAL_STATUS.WAITING) {
      return (
        <Tag
          color={isRejected ? null : "orange"}
          style={{
            ...styleTag,
            opacity: isRejected ? 0.5 : 1,
          }}
        >
          Chờ duyệt
        </Tag>
      );
    }

    if (status === PROPOSAL_STATUS.CREATED) {
      return (
        <Tag color={"cyan"} style={styleTag}>
          Đã tạo
        </Tag>
      );
    }
    if (status === PROPOSAL_STATUS.APPROVED) {
      return (
        <Tag color={"green"} style={styleTag}>
          Đã duyệt
        </Tag>
      );
    }
    if (status === PROPOSAL_STATUS.REJECTED) {
      return (
        <Tag color={"red"} style={styleTag}>
          Đã từ chối
        </Tag>
      );
    }
  };

  // Tìm title của proposal_type
  const proposalTypeName = arrSubmissionMenu
    ?.find((el) =>
      el.child.find((els) => els.id_child === otherDetail?.proposal_type)
    )
    ?.child.find((els) => els.id_child === otherDetail?.proposal_type);

  const numberOfColumns =
    otherDetail?.proposal_type !== "BUSINESS_TRIP" &&
    otherDetail?.proposal_type !== "OVERTIME_NORMAL"
      ? 4
      : 3;
  const columnWidth = `${100 / numberOfColumns}%`;

  const columns = [
    {
      title: "Ngày làm việc",
      dataIndex: "date",
      key: "date",
      width: columnWidth,
      render: text => <span>{moment(text).format("DD/MM/YYYY")}</span>,
    },
    {
      title: "Buổi làm việc",
      dataIndex: "shift",
      key: "shift",
      width: columnWidth,
      render: key => {
        let value;
        switch (key) {
          case SHIFTS.ALL_DAY.key:
            value = SHIFTS.ALL_DAY.value;
            break;
          case SHIFTS.MORNING.key:
            value = SHIFTS.MORNING.value;
            break;
          case SHIFTS.AFTERNOON.key:
            value = SHIFTS.AFTERNOON.value;
            break;
          case SHIFTS.EMPTY.key:
            value = SHIFTS.EMPTY.value;
            break;
          default:
        }
        return <span>{value}</span>;
      },
    },
    ...(otherDetail?.proposal_type !== "BUSINESS_TRIP" &&
    otherDetail?.proposal_type !== "OVERTIME_NORMAL"
      ? [
          {
            title: "Loại nghỉ phép",
            dataIndex: "mode",
            key: "mode",
            width: columnWidth,
            render: key => {
              let value;
              switch (key) {
                case MODES.NORMAL.key:
                  value = MODES.NORMAL.value;
                  break;
                case MODES.SPECIAL.key:
                  value = MODES.SPECIAL.value;
                  break;
                case MODES.WOMEN.key:
                  value = MODES.WOMEN.value;
                  break;
                case MODES.CHILD_CARE.key:
                  value = MODES.CHILD_CARE.value;
                  break;
                default:
              }
              return <span>{value}</span>;
            },
          },
        ]
      : []),
    ...(otherDetail?.proposal_type === "OVERTIME_NORMAL"
      ? [
          {
            title: "Giờ",
            dataIndex: "mode_type",
            key: "mode_type",
            width: "17.5%",
            render: (key, record) => (
              <span style={{ textAlign: "center" }}>{record.mode_type}</span>
            ),
          },
        ]
      : []),
    {
      title: "Ghi chú",
      dataIndex: "note",
      key: "note",
      width: columnWidth,
      render: text => (
        <div style={{ maxHeight: "100px", overflowY: "auto" }}>{text}</div>
      ),
    },
  ]

  const leaveAbnormalColumns = [
    {
      title: "Ngày làm việc",
      dataIndex: "date",
      key: "date",
      width: "17.5%",
      render: text => <span>{moment(text).format("DD/MM/YYYY")}</span>,
    },
    {
      title: "Buổi làm việc",
      dataIndex: "shift",
      key: "shift",
      width: "17.5%",
      render: key => {
        let value;
        switch (key) {
          case SHIFTS.ALL_DAY.key:
            value = SHIFTS.ALL_DAY.value;
            break;
          case SHIFTS.MORNING.key:
            value = SHIFTS.MORNING.value;
            break;
          case SHIFTS.AFTERNOON.key:
            value = SHIFTS.AFTERNOON.value;
            break;
          case SHIFTS.EMPTY.key:
            value = SHIFTS.EMPTY.value;
            break;
          default:
        }
        return <span>{value}</span>;
      },
    },
    {
      title: "Loại nghỉ phép",
      dataIndex: "mode",
      key: "mode",
      width: "17.5%",
      render: key => {
        let value;
        switch (key) {
          case MODES.NORMAL.key:
            value = MODES.NORMAL.value;
            break;
          case MODES.SPECIAL.key:
            value = MODES.SPECIAL.value;
            break;
          case MODES.WOMEN.key:
            value = MODES.WOMEN.value;
            break;
          case MODES.CHILD_CARE.key:
            value = MODES.CHILD_CARE.value;
            break;
          case MODES.WORK_REASON.key:
            value = MODES.WORK_REASON.value;
            break;
          case MODES.BY_REGIME.key:
            value = MODES.BY_REGIME.value;
            break;
          default:
        }
        return <span>{value}</span>;
      },
    },
    {
      title: "Loại chế độ (giờ)",
      dataIndex: "mode_type",
      key: "mode_type",
      width: "17.5%",
      render: (key, record) => (
        <span style={{ textAlign: "center" }}>{record.mode_type}</span>
      ),
    },
    {
      title: "Ghi chú",
      dataIndex: "note",
      key: "note",
      width: "30%",
      render: text => (
        <div style={{ maxHeight: "100px", overflowY: "auto" }}>{text}</div>
      ),
    },
  ];

  const handleNavigateBack = async () => {
    if (isModalOpen) {
      navigate(-2);
    } else {
      navigate(-1);
    }
    await proposalStore.getProposals(params);
  };
  return (
    <>
      {loading ? (
        <SkeletonProposalDetail />
      ) : (
        <Fragment>
          <div
            className="flex items-center gap-[22px] fixed w-full z-50"
            style={{
              background: theme.background.header,
              color: theme.color.text1,
            }}
          >
            <ArrowLeftCircle
              style={{ marginLeft: "10px" }}
              className="flex-shrink-0"
              onClick={handleNavigateBack}
            />
            <div className="w-full h-20 flex items-center justify-between overflow-hidden">
              <div
                className="font-bold text-[28px] leading-[29px] truncate w-1/2"
                style={{
                  overflow: "hidden",
                  whiteSpace: "nowrap",
                  textOverflow: "ellipsis",
                  width: "100%",
                  lineHeight: "35px",
                }}
              >
                {otherDetail.title}
              </div>
              <div className="w-1/2 flex justify-end">
                <StatusTag
                  typePage={TYPE_STATUS.PROPOSAL}
                  status={otherDetail.proposal_status}
                />
              </div>
            </div>
          </div>
          <div className="mb-24 pt-20">
            <div className="m-4 border border-[#2c65ac] rounded-lg">
              <div
                className="bg-blue-600 px-4 py-2 rounded-t-lg"
                style={{
                  background: theme.background.header,
                  color: theme.color.text1,
                }}
              >
                Tiến trình duyệt
              </div>
              <div className="m-4 h-[400px] overflow-y-auto">
                <Box sx={{ maxWidth: 400 }}>
                  <Stepper activeStep={activeStep} orientation="vertical">
                    {approvalLevels.map((step, index) => {
                      const assignTypeIndex = otherDetail.approval_levels
                        .filter((el) => el.allow_edit)
                        .findIndex((item) => item.level === step.level);
                      const handleDeleteUser = () => {
                        if ([0, 1, 2, 3].includes(assignTypeIndex)) {
                          selectPeopleStore.handleRemoveSelect({
                            assignee_type: ASSIGNEE_TYPE.USER,
                            id: step.username,
                            permission: ASSIGNEE_TYPE_CONFIG[assignTypeIndex],
                          });
                        }
                      };
                      return (
                        <>
                          <Step key={step.key} expanded={true}>
                            <StepLabel
                              className="relative"
                              optional={
                                index !== 0 ? (
                                  <div className="absolute -mt-6 text-red-500 text-lg">
                                    *
                                  </div>
                                ) : null
                              }
                            >
                              <span className="ml-2 text-[16px]">
                                {step.name}
                              </span>
                            </StepLabel>
                            <StepContent>
                              <div>
                                <div className="inline-block flex items-center">
                                  {step.username === undefined ? (
                                    <div className="border px-2 py-1 rounded-full">
                                      Chưa gán người!
                                    </div>
                                  ) : (
                                    <div>
                                      {handlerList.length ? (
                                        <SelectList>
                                          {handlerList.map((el) => {
                                            return (
                                              <div
                                                name="assignees"
                                                className={"tag-selected"}
                                                color={"blue"}
                                                key={el.id}
                                                closable
                                                onClose={handleDeleteUser}
                                              >
                                                <AvatarHasName
                                                  imgId={el.image_id}
                                                  size={22}
                                                  name={el.full_name}
                                                  icon={
                                                    (el.assignee_type ===
                                                      ASSIGNEE_TYPE.DEPARTMENT && (
                                                      <AiFillBank />
                                                    )) ||
                                                    (el.assignee_type ===
                                                      ASSIGNEE_TYPE.GROUP && (
                                                      <AiFillBank />
                                                    ))
                                                  }
                                                />
                                              </div>
                                            );
                                          })}
                                        </SelectList>
                                      ) : (
                                        <SelectList>
                                          <Tag
                                            className={"tag-selected"}
                                            color={"blue"}
                                            key={step.id}
                                          >
                                            <AvatarHasName
                                              imgId={step.image_id}
                                              size={22}
                                              name={step.user.full_name}
                                            />
                                          </Tag>
                                        </SelectList>
                                      )}
                                    </div>
                                  )}
                                  {step.allow_edit === true ? (
                                    <div
                                      className="ml-2"
                                      onClick={() => {
                                        handleOpenSelectUser(step.level);
                                      }}
                                    >
                                      <div className="border p-2 rounded-lg text-[#2C65AC]">
                                        <User height={20} width={20} />
                                      </div>
                                    </div>
                                  ) : null}
                                </div>
                                <div className="mb-2">
                                  {renderStatus(
                                    step.status,
                                    statusStep === "error"
                                  )}
                                </div>
                                {index === 0 ? (
                                  <div className="text-sm">
                                    {moment(step.created_at).format(
                                      "HH:mm - DD/MM/YYYY"
                                    )}
                                  </div>
                                ) : null}
                              </div>
                            </StepContent>
                          </Step>
                        </>
                      );
                    })}
                  </Stepper>
                  {isShowButtonAction && (
                    <div style={groupBtnStyle}>
                      <AccessControlAction
                        aclActionType={ACL_ACTION_TYPE.approve__PROPOSAL}
                      >
                        <Button
                          danger
                          onClick={() =>
                            handleOpenConfirmModal(PROPOSAL_STATUS.REJECT)
                          }
                        >
                          Từ chối
                        </Button>
                      </AccessControlAction>
                      <AccessControlAction
                        aclActionType={ACL_ACTION_TYPE.approve__PROPOSAL}
                      >
                        <Button
                          type={"primary"}
                          onClick={() =>
                            handleOpenConfirmModal(PROPOSAL_STATUS.APPROVAL)
                          }
                        >
                          Duyệt yêu cầu
                        </Button>
                      </AccessControlAction>
                    </div>
                  )}
                </Box>
              </div>
            </div>
            <div className="m-4 border border-[#2c65ac] rounded-lg">
              <div
                className="bg-blue-600 px-4 py-2 rounded-t-lg flex items-center"
                style={{
                  background: theme.background.header,
                  color: theme.color.text1,
                }}
              >
                Nội dung :
                {otherDetail?.reason ? (
                  <div
                    className="ml-2 underline "
                    onClick={() => setOpenModal(true)}
                  >
                    Chi tiết
                  </div>
                ) : null}
              </div>
              {otherDetail?.reason ? (
                <div
                  className="overflow-x-auto m-4 h-[50px]"
                  dangerouslySetInnerHTML={{
                    __html: otherDetail?.reason,
                  }}
                />
              ) : (
                <div className="italic m-4">Không có nội dung</div>
              )}
            </div>
            <div className="m-4 border border-[#2c65ac] rounded-lg">
              <div
                className="bg-blue-600 px-4 py-2 rounded-t-lg"
                style={{
                  background: theme.background.header,
                  color: theme.color.text1,
                }}
              >
                Thông tin chung
              </div>
              <div className="m-4">
                {/* Loại hành chính */}
                <div className="mb-3">
                  <span className="font-bold mr-1">Loại:</span>
                  {proposalTypeName.name_child}
                </div>

                {/* Tài liệu đính kèm */}
                <div>
                  <div className="flex">
                    <div className="font-bold">Tài liệu đính kèm:</div>
                    {otherDetail?.attachments.length > 0 ? (
                      <div className="ml-1">
                        {otherDetail?.attachments.map((file) => (
                          <FileItem
                            file={file}
                            key={file.file_id}
                            file_id={file.file_id}
                            file_name={file.file_name}
                            file_type={getExtensionFile(file.file_name)}
                          />
                        ))}
                      </div>
                    ) : (
                      <div className="ml-1 mt-1 mb-3 italic text-[12px]">
                        Không có tài liệu đính kèm.
                      </div>
                    )}
                  </div>
                </div>

                {/* Người theo dõi */}
                <div className="mb-3">
                  <div className="flex items-center">
                    <span className="font-bold">Người theo dõi:</span>
                    {otherDetail?.followers.length > 0 ? (
                      <div className="-mt-2">
                        {otherDetail?.followers.map((item, index) => (
                          <div
                            key={index}
                            className="border px-1 rounded-md text-blue-500 m-1"
                          >
                            {capitalizeFirstLetter(item.name_lowercase)}
                          </div>
                        ))}
                      </div>
                    ) : (
                      <div className="ml-1 italic text-[12px]">
                        Không có người theo dõi.
                      </div>
                    )}
                  </div>
                </div>

                {/* Loại nghỉ phép */}
                {otherDetail?.type_of_leave ? (
                  <div className="mb-3">
                    <span className="font-bold">Loại nghỉ phép:</span>{" "}
                    {otherDetail?.type_of_leave}
                  </div>
                ) : null}

                {/* Lý do */}
                {otherDetail?.reason_for_leaving ? (
                  <div className="mb-3">
                    <span className="font-bold">Lý do:</span>{" "}
                    {otherDetail?.reason_for_leaving}
                  </div>
                ) : null}

                {/* Thời gian - ngày bắt đầu - ngày kết thúc */}
                <div className="mb-3">
                  <div className="flex items-center mb-3">
                    <span className="font-bold">Ngày bắt đầu:</span>
                    <div className="ml-1">
                      {moment(otherDetail?.from_date).format("DD/MM/YYYY")}
                    </div>
                  </div>
                  <div className="flex items-center">
                    <span className="font-bold">Ngày kết thúc:</span>
                    <div className="ml-1">
                      {moment(otherDetail?.to_date).format("DD/MM/YYYY")}
                    </div>
                  </div>
                </div>

                {workingDaysList?.length > 0 &&
                  (otherDetail?.proposal_type === "BUSINESS_TRIP" ||
                    otherDetail?.proposal_type === "LEAVE" ||
                    otherDetail?.proposal_type === "RETIMEKEEPING" ||
                    otherDetail?.proposal_type === "OVERTIME_NORMAL" ||
                    otherDetail?.proposal_type === "LEAVE_ABNORMAL") && (
                    <>
                      <Table
                        rowKey={record => record.id}
                        className="custom-table-working-days-list"
                        columns={
                          otherDetail?.proposal_type === "LEAVE_ABNORMAL"
                            ? leaveAbnormalColumns
                            : columns
                        }
                        dataSource={workingDaysList}
                        pagination={false}
                        scroll={{
                          x: 600,
                        }}
                      />
                    </>
                  )}

                {/* Thêm giờ */}
                {otherDetail?.overtime ? (
                  <>
                    <div className="mb-3">
                      <span className="font-bold">Số giờ làm thêm:</span>
                      {otherDetail?.overtime ? (
                        <span className="ml-1">
                          {otherDetail?.overtime} giờ
                        </span>
                      ) : (
                        <span className="ml-1 italic text-[12px]">
                          Không có số giờ làm thêm.
                        </span>
                      )}
                    </div>
                    <div className="flex items-center">
                      <span className="font-bold">Số giờ được duyệt:</span>

                      {otherDetail?.approvalOvertime ? (
                        <div className="ml-1">
                          {otherDetail?.approvalOvertime} giờ
                        </div>
                      ) : (
                        <div className="ml-1 italic text-[12px]">
                          Không có số giờ được duyệt.
                        </div>
                      )}
                    </div>
                  </>
                ) : null}
              </div>
            </div>

            {otherCommentList?.length > 0 ? (
              <div className="m-4 border border-[#2c65ac] rounded-lg">
                <div
                  className="flex items-center bg-blue-600 px-4 py-2 rounded-t-lg"
                  style={{
                    background: theme.background.header,
                    color: theme.color.text1,
                  }}
                >
                  <div className="mr-2">Danh sách ý kiến</div>
                  <MoreHorizCircle onClick={handleClick} />
                  {menu}
                </div>
                <>
                  {commentProposalListDeleted?.length > 0 ? (
                    <div>
                      {openCmtDel ? (
                        <ListComment
                          loadingCmt={loadingCmt}
                          commentWorkList={commentProposalListDeleted}
                          setDeleteItem={setDeleteItem}
                        />
                      ) : (
                        ""
                      )}
                      <ListComment
                        loadingCmt={loadingCmt}
                        commentWorkList={commentProposalListNotDeleted}
                        setDeleteItem={setDeleteItem}
                      />
                    </div>
                  ) : (
                    <>
                      {commentProposalListNotDeleted?.length > 0 && (
                        <div>
                          {openCmtDel ? (
                            <ListComment
                              loadingCmt={loadingCmt}
                              commentWorkList={commentProposalListDeleted}
                              setDeleteItem={setDeleteItem}
                            />
                          ) : (
                            ""
                          )}
                          <ListComment
                            loadingCmt={loadingCmt}
                            commentWorkList={commentProposalListNotDeleted}
                            setDeleteItem={setDeleteItem}
                          />
                        </div>
                      )}
                    </>
                  )}
                </>
              </div>
            ) : null}
          </div>
          <footer
            style={{
              position: "fixed",
              bottom: 0,
              backgroundColor: "white",
            }}
            className="flex items-center justify-between w-full py-4 rounded-t-[10px] shadow-[0px_0px_8px_rgba(0,0,0,0.25)]"
          >
            <div className="flex justify-around w-full h-full">
              <div className="block text-center">
                <div
                  className="bg-[rgba(0,115,199,0.07)] inline-block text-blue-500 hover:bg-cyan-400 hover:text-white py-[8px] px-[8px] rounded-full text-sm font-medium"
                  onClick={() => setOpenCmtModal(true)}
                >
                  <AiOutlineComment style={{ width: "20px", height: "20px" }} />
                </div>
                <div style={{ fontSize: "10px" }}>Đăng ý kiến</div>
              </div>

              <div className="block text-center ">
                <div
                  onClick={() => {
                    setOpenEditProposal(true);
                    setCount(count + 1);
                    setIsModalOpen(true);
                  }}
                  className="hover:bg-cyan-400 inline-block
              bg-[rgba(0,115,199,0.07);] text-blue-500 hover:text-white py-[8px]
              text-center px-[8px] rounded-full text-sm font-medium"
                >
                  <AiOutlineEdit style={{ width: "20px", height: "20px" }} />
                </div>
                <div style={{ fontSize: "11px" }}>Chỉnh sửa</div>
              </div>

              <div className="text-center ">
                <div
                  className="hover:bg-cyan-400 inline-block bg-[rgba(0,115,199,0.07)] text-red-500 hover:text-white  py-[8px] px-[8px] rounded-full text-sm font-medium"
                  onClick={() => showConfirmDeleteProposal()}
                >
                  <AiOutlineDelete style={{ width: "20px", height: "20px" }} />
                </div>
                <div style={{ fontSize: "10px" }}>Xóa</div>
              </div>
            </div>
          </footer>
          <SelectPeoplePopup
            onlyOneUser
            handleCancelSelectUser={handleSubmitSelectUser}
            handleSubmitSelectUser={handleSubmitSelectUser}
            isVisibleSelectPeoplePopup={isVisibleSelectUserPopup}
          />
          <ProposalModal
            reason={otherDetail?.reason}
            open={openModal}
            handleClose={() => {
              setOpenModal(false);
            }}
          />
          <ProposalComment
            open={openCmtModal}
            handleClose={() => {
              setOpenCmtModal(false);
            }}
            proposalCode={otherDetail.proposal_code}
            onCommentSuccess={onCommentSuccess}
          />
          <AlertDialog
            open={deleteItem.open}
            handleClose={() => setDeleteItem({ open: false, comment_id: "" })}
            handleDelete={handleDeleteComment}
          />
          <ProposalActionConfirmModal
            isModalVisible={isConfirmModalVisible}
            handleCloseModal={handleCloseModal}
            confirmModalType={confirmModalType}
          />
          {openEditProposal && (
            <UpdateProposal
              count={count}
              setCount={setCount}
              open={openEditProposal}
              handleClose={() => {
                setOpenEditProposal(false);
              }}
              otherDetail={otherDetail}
              proposalTypeName={proposalTypeName}
              proposalType={otherDetail?.proposal_type}
            />
          )}
        </Fragment>
      )}
    </>
  );
};

export default memo(
  inject(
    "proposalStore",
    "selectPeopleStore",
    "proposalTypeStore",
    "authenticationStore"
  )(observer(ProposalDetail))
);
